module.exports = __webpack_public_path__ + "img/allgemeine-struktur.d6c4fbfa.png";